import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { queryFileList } from '@/api/api';
import PDFModal from '@comp/PDFView/PDFModal';
export default {
  components: {
    PDFModal: PDFModal
  },
  data: function data() {
    fileList: null;
  },
  props: {
    companyId: {
      default: 0,
      type: Number
    }
  },
  watch: {
    companyId: {
      handler: function handler(val) {
        if (val) {
          this.getList();
        }
      },
      immediate: true
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      queryFileList('site_company', this.companyId).then(function (res) {
        if (res.success) {
          var docsList = [];

          for (var i = 0; i < res.result.length; i++) {
            var doc = res.result[i];
            doc.key = doc.id;
            docsList.push(doc);
          }

          _this.fileList = docsList;

          _this.$forceUpdate();
        }
      });
    },
    // 预览
    openPDF: function openPDF(item) {
      this.$refs.pdfview.showPDF(item.id + '-' + item.fileName, window._CONFIG['domianURL'] + '/sys/common/file/view/' + item.id, 'online');
    },

    /* 文件下载 */
    downUploadFile: function downUploadFile(text) {
      if (!text) {
        this.$message_custom('未知的文件', 'warning');
        return;
      }

      window.open(window._CONFIG['domianURL'] + '/sys/common/file/download/' + text);
    },
    getFileType: function getFileType(item) {
      if (item.suffixName.indexOf("png") == -1 && item.suffixName.indexOf("jpg") == -1 && item.suffixName.indexOf("svg") == -1 && item.suffixName.indexOf("jpeg") == -1) {
        // 下载文件
        this.downUploadFile(item.id);
      } else {
        // 预览图片
        this.openPDF(item);
      }
    }
  }
};